import { Component, OnInit } from '@angular/core';

// Service
import { ApiService } from '../../shared/service/api.service';
@Component({
  selector: 'app-sustainability',
  templateUrl: './sustainability.component.html',
  styles: [
  ]
})
export class SustainabilityComponent implements OnInit {

  dataBanner;
  
  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.apiService.getDataApi('getSubHeaderByLink/sustainability').subscribe(response => {
       this.dataBanner = response.data;
    });
  }

}
